import React, { useState } from "react";
import { history } from "../../_redux/_store/history";
import queryString from "query-string";
import Button from "@material-ui/core/Button";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import {
  Typography,
  TextField,
  IconButton,
  makeStyles,
  Grid,
  Snackbar,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { useDispatch, useSelector } from "react-redux";

import ErrorHandler from "../updateHandlers/ErrorHandler";
import SelectScopeMenu from "../selectScope/SelectScopeMenu";
import {
  clearScopedAnomalyState,
  createScopedAnomalyRule,
} from "../../_redux/_actions/scopedAnomalyRuleActions";
import { useEffect } from "react";
import { selectAnomalyRulePageSelect } from "../../_redux/_actions/selectScopedAnomalyRuleAction";

const useStyles = makeStyles(() => ({
  alignBottom: {
    alignSelf: "flex-end",
  },
  dialogAction: {
    justifyContent: "flex-start",
  },
  label: {
    fontWeight: "bold",
    margin: "5px",
  },
  notes: {
    width: "95%",
    // overflowY: "scroll",
  },
  caption: {
    padding: "8px",
  },
}));

const Dialog = withStyles(() => ({
  paper: {
    padding: "30px",
  },
  paperScrollPaper: {
    height: "526px",
    width: "1060px",
  },
  paperWidthSm: {
    maxWidth: "1200px",
  },
}))(MuiDialog);

const DialogTitle = withStyles(() => ({
  root: {
    padding: "16px 0px",
  },
}))(MuiDialogTitle);

const DialogContent = withStyles(() => ({
  root: {
    width: "100%",
    // backgroundColor: "white",
    overflow:'hidden',
    alignSelf: "center",
    padding: "0px",
  },
}))(MuiDialogContent);

const DialogActions = withStyles(() => ({
  root: {
    justifyContent: "flex-start",
  },
}))(MuiDialogActions);

function CreateScopedAnomalyRule(props) {
  const {
    handleScopedAnomalyDialog,
    ruleId,
    scopedAnomalyOpen,
    createSuccessFlag,
  } = props;

  const classes = useStyles();
  const [note, setNote] = useState("");
  const [scope, setScope] = useState("");
  const [error, setError] = useState(false);
  const scopedAnomalyResponse = useSelector((state) => state.scopedAnomalyRule);
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(selectAnomalyRulePageSelect("createScopedAnomalyRule"));
  }, []);

  const clearStates = () => {
    setNote("");
    setScope("");
    setError("");
  };

  const getScopeData = (scope) => {
    setScope(scope);
  };

  const handleDone = () => {
    setError("");
    const body = {
      anomaly_rule_id: ruleId,
      scope: !scope ? 'global:' : scope,
      parameters: "",
      note_text: note,
    };
    dispatch(createScopedAnomalyRule(body,machine_type, hmi_type, createSuccessFlag));
  };

  return (
    <>
      <Dialog
        open={scopedAnomalyOpen}
      >
        <DialogTitle>
          <Grid container justifyContent='space-between'>
            <Typography style={{ color: "#52A1C2", fontWeight: 700 }} >
              Create New Scoped Anomaly Rule
            </Typography>
            <IconButton
              aria-label='close'
              className={classes.closeButton}
              onClick={() => {
                clearStates();
                dispatch(clearScopedAnomalyState());
                handleScopedAnomalyDialog();
              }}
            >
              <CancelRoundedIcon style={{ color: "#666666" }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {scopedAnomalyResponse.error && (
            <ErrorHandler message={scopedAnomalyResponse.error} />
          )}
          {scopedAnomalyResponse.createError && (
            <Snackbar
              message={scopedAnomalyResponse.createError}
              open={scopedAnomalyResponse.createError ? true : false}
              onClose={() => dispatch(clearScopedAnomalyState())}
              autoHideDuration={2000}
            />
          )}

          <Grid
            container
            direction='column'
            spacing={3}
            justifyContent='space-between'
          >
            <Grid item>
              <Typography className='text-secondary' variant='subtitle2'>
                Note Text
              </Typography>
            </Grid>
            <Grid item>
              <TextField
                className={classes.notes}
                label='Add Note Text for Scoped Anomaly Rule'
                rows={4}
                multiline
                variant='outlined'
                onChange={(event) => {
                  setNote(event.target.value);
                }}
              />
            </Grid>
            <Grid item>
              <Typography variant='caption'>
                Select a scope and proceed to configure the parameters
              </Typography>
            </Grid>
            <Grid item container>
              <SelectScopeMenu getScopeData={getScopeData} createScopedAnomalyRule ="createScopedAnomalyRule" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            className='btn-primary'
            color='primary'
            onClick={() => {
              dispatch(clearScopedAnomalyState());
              handleDone();
            }}
          >
            Done
          </Button>
          <Button
            color='primary'
            onClick={() => {
              clearStates();
              dispatch(clearScopedAnomalyState());
              handleScopedAnomalyDialog();
            }}
          >
            Cancel
          </Button>
        </DialogActions>
        <Snackbar
          message={error}
          open={error ? true : false}
          onClose={() => setError(false)}
          autoHideDuration={3000}
        />
      </Dialog>
      {/* <CreateSuccessDialog /> */}
    </>
  );
}

export default React.memo(CreateScopedAnomalyRule);
